import { createFileRoute } from '@tanstack/react-router';
import { DragAndDropProvider } from '@/components/shared/dnd-kit/drag-and-drop';
import { CompanyDashboard } from '@/components/company/dashboard/company-dashboard';

export const Route = createFileRoute('/(app)/company/dashboard/')({
  component: CompanyDashboardPage,
});

function CompanyDashboardPage() {
  return (
    <DragAndDropProvider>
      <CompanyDashboard />
    </DragAndDropProvider>
  );
}
